// src/components/navigation/Header.tsx
import React from 'react';
import { useHeaderContext } from '../../contexts/HeaderContext';

const Header: React.FC = () => {
  const { config } = useHeaderContext();

  // 如果沒有配置，不渲染任何內容
  if (!config) {
    return null;
  }

  const { title, subtitle, leftAction, rightActions, className } = config;

  return (
    <header className={`header-wrapper ${className || ''}`}>
      <div className="header-container">
        {/* 左側：左側操作 + 標題區域 */}
        <div className="header-title-area">
          <div className="header-left-content">
            {/* 左側操作按鈕 */}
            {leftAction && (
              <div className="header-left-action">
                {leftAction}
              </div>
            )}

            {/* 標題區域 */}
            {subtitle ? (
              <div className="header-title-group">
                <h1 className="header-title">
                  {title}
                </h1>
                <div className="header-subtitle">
                  {subtitle}
                </div>
              </div>
            ) : (
              <h1 className="header-title">
                {title}
              </h1>
            )}
          </div>
        </div>

        {/* 右側：操作按鈕組 */}
        {rightActions && rightActions.length > 0 && (
          <div className="header-actions">
            {rightActions.map((action, index) => (
              <div key={index}>
                {action}
              </div>
            ))}
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;